import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Timestamp } from '@angular/fire/firestore';
import { AppConfigService, AppConfig } from '../../services/app-config.service';
import { Auth } from '@angular/fire/auth';
import { toSignal } from '@angular/core/rxjs-interop';
import { user } from '@angular/fire/auth';
import { firstValueFrom, take } from 'rxjs';

@Component({
  selector: 'app-mantenimiento',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './mantenimiento.component.html',
})
export class MantenimientoComponent implements OnInit {
  private readonly configSvc = inject(AppConfigService);
  private readonly auth = inject(Auth);

  readonly currentUser = toSignal(user(this.auth));
  readonly config = signal<AppConfig | null>(null);
  readonly loading = signal(true);

  async ngOnInit(): Promise<void> {
    const cfg = await firstValueFrom(this.configSvc.config$.pipe(take(1)));
    this.config.set(cfg);
    this.loading.set(false);
  }

  formatDate(ts: Timestamp | null | undefined): string {
    if (!ts) return '';
    return ts.toDate().toLocaleDateString('es-ES', {
      weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
    });
  }
}
